/*
 * Swee Choon delivery calendar — v1 (5 Oct 2026)
 * One set of delivery-date rules for catering product pages, the cart and the online order builder.
 * Rules come from Shopify admin → Content → Metaobjects → "Catering delivery calendar",
 * rendered into window.SC_DELIVERY_CAL by snippets/sc-delivery-calendar-config.liquid.
 *
 * Saves the date on the cart in the same format the Order Delivery Date app used, so order
 * emails, the catering calendar sync and staff views keep working:
 *   product_<variantId> = "TITLE |&| dd/mm/yyyy |&| Weekday |&| hh:mm AM"
 *   calendar_type = product, Date Format = dd/mm/yy, _sc_dc = v1
 *
 * mode "test": UI only runs for browsers that opened ?view=dc-test, the test order builder,
 * any URL with ?sc_dc_test=1, or the cart in that same tab. Live customers are unaffected.
 */
(function () {
  var CFG = window.SC_DELIVERY_CAL;
  if (!CFG || window.SCDC) return;

  // Test mode is limited to: the ?view=dc-test product template, the test order builder,
  // any URL with ?sc_dc_test=1, and the cart page in the same tab straight after one of those.
  // It never spreads to ordinary product pages (fix 5 Oct: was localStorage, domain-wide).
  var SS_TEST = 'sc_dc_test';
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  try { localStorage.removeItem('sc_dc_test'); } catch (e) {}
  if (/[?&]sc_dc_test=0/.test(location.search)) ssDel(SS_TEST);
  var TEST_HERE = /[?&]sc_dc_test=1/.test(location.search) || CFG.template === 'dc-test' || CFG.page === 'test-catering-configurator';
  if (TEST_HERE) ssSet(SS_TEST, '1');
  var ACTIVE = CFG.mode === 'live' || TEST_HERE || (CFG.templateName === 'cart' && ssGet(SS_TEST) === '1');

  var realFetch = window.fetch.bind(window);
  var DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // ---------- date engine (Singapore time, independent of device time zone) ----------
  function sgNow() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: CFG.tz || 'Asia/Singapore', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var h = +p.hour; if (h === 24) h = 0;
    return { ymd: p.year + '-' + p.month + '-' + p.day, mins: h * 60 + (+p.minute) };
  }
  function toD(s) { var a = s.split('-'); return new Date(Date.UTC(+a[0], +a[1] - 1, +a[2], 12)); }
  function toS(d) { return d.toISOString().slice(0, 10); }
  function addDays(s, n) { var d = toD(s); d.setUTCDate(d.getUTCDate() + n); return toS(d); }
  function dow(s) { return toD(s).getUTCDay(); }
  function pretty(s) { if (!s) return ''; var d = toD(s); return DOW[d.getUTCDay()].slice(0, 3) + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()] + ' ' + d.getUTCFullYear(); }
  function t12(hhmm) { if (!hhmm) return ''; var a = hhmm.split(':'); var h = +a[0]; var ap = h < 12 ? 'AM' : 'PM'; var h12 = (h % 12) || 12; return (h12 < 10 ? '0' : '') + h12 + ':' + a[1] + ' ' + ap; }
  function t12short(hhmm) { var s = t12(hhmm); return s.replace(/^0/, '').replace(':00 ', ' ').replace(' AM', 'am').replace(' PM', 'pm'); }
  function from12(s) { var m = /(\d{1,2}):(\d{2})\s*(AM|PM)/i.exec(s || ''); if (!m) return ''; var h = +m[1] % 12; if (/pm/i.test(m[3])) h += 12; return (h < 10 ? '0' : '') + h + ':' + m[2]; }
  function dmyToYmd(s) { var m = /(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(s || ''); return m ? m[3] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[1]).slice(-2) : ''; }
  function ymdToDmy(s) { var a = s.split('-'); return a[2] + '/' + a[1] + '/' + a[0]; }

  var GROUPS = (CFG.groups || []).map(function (g) {
    return { key: g.key, name: g.name, builder: !!g.builder, notice: +g.notice || 0, cutoff: g.cutoff || '', max: +g.max || 180, slots: g.slots || [], closed: g.closed || [], blocked: g.blocked || [], products: (g.products || []).map(Number) };
  });
  function group(key) { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].key === key) return GROUPS[i]; return null; }
  function groupForProduct(pid) { pid = Number(pid); for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].products.indexOf(pid) >= 0) return GROUPS[i]; return null; }
  function builderGroup() { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].builder) return GROUPS[i]; return GROUPS[0] || null; }

  function rules(g, extraMin) {
    var now = sgNow(), late = false;
    if (g.cutoff) { var c = g.cutoff.split(':'); late = now.mins >= (+c[0]) * 60 + (+c[1]); }
    var min = addDays(now.ymd, g.notice + (late ? 1 : 0));
    if (extraMin && extraMin > min) min = extraMin;
    var max = addDays(now.ymd, g.max);
    var blocked = {}; g.blocked.forEach(function (b) { blocked[b] = 1; });
    var closed = {}; g.closed.forEach(function (n) { var i = DOW.indexOf(n); if (i >= 0) closed[i] = 1; });
    var r = { group: g, today: now.ymd, min: min, max: max, late: late, slots: g.slots };
    r.status = function (s) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(s || '')) return 'missing';
      if (s < min) return 'notice';
      if (s > max) return 'toofar';
      if (blocked[s]) return 'blocked';
      if (closed[dow(s)]) return 'closed';
      return 'ok';
    };
    r.first = (function () { for (var d = min, i = 0; d <= max && i < 800; d = addDays(d, 1), i++) if (r.status(d) === 'ok') return d; return ''; })();
    r.message = function (st) {
      if (st === 'missing') return 'Please choose a delivery date.';
      if (st === 'notice') return 'This date is too soon. We need ' + g.notice + ' days\u2019 notice' + (g.cutoff ? ' (orders after ' + t12short(g.cutoff) + ' need one more day)' : '') + '. The earliest available date is ' + pretty(r.first) + '.';
      if (st === 'toofar') return 'We take bookings up to ' + pretty(max) + '. Please choose an earlier date.';
      if (st === 'blocked' || st === 'closed') return 'Sorry, we can\u2019t deliver on ' + '\u0000' + '. Please choose another date.';
      return '';
    };
    r.check = function (s, time) {
      var st = r.status(s);
      if (st !== 'ok') return r.message(st).replace('\u0000', pretty(s));
      if (time !== undefined && r.slots.length && r.slots.indexOf(time) < 0) return 'Please choose a delivery time.';
      return '';
    };
    r.noticeText = function () {
      return 'We need ' + g.notice + ' days\u2019 notice' + (g.cutoff ? ' (orders after ' + t12short(g.cutoff) + ' need one more day)' : '') + '. Earliest available: ' + pretty(r.first) + '.';
    };
    return r;
  }

  // ---------- UI ----------
  function css() {
    if (document.getElementById('scdc-css')) return;
    var s = document.createElement('style'); s.id = 'scdc-css';
    s.textContent = [
      '.scdc-box{border:1px solid #ae0a2b;border-radius:6px;padding:14px 16px;margin:14px 0;font-family:Jost,sans-serif;background:#fff;color:#222;text-align:left}',
      '.scdc-box .scdc-cal,.scdc-box .scdc-time{margin-left:0;margin-right:auto}',
      '.scdc-box.scdc-err{box-shadow:0 0 0 2px #ae0a2b inset;background:#fff7f8}',
      '.scdc-title{font-weight:600;color:#ae0a2b;letter-spacing:.06em;font-size:13px;text-transform:uppercase;margin:0 0 2px}',
      '.scdc-sub{font-size:12.5px;color:#666;margin:0 0 10px;line-height:1.4}',
      '.scdc-lbl{display:block;font-weight:600;font-size:14px;margin:10px 0 6px}',
      '.scdc-lbl b{color:#ae0a2b}',
      '.scdc-cal{border:1px solid #e3d6d6;border-radius:6px;padding:8px;max-width:360px;user-select:none}',
      '.scdc-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:6px}',
      '.scdc-head span{font-weight:600;font-size:15px}',
      '.scdc-nav{background:#fff;border:1px solid #ddd;border-radius:4px;width:34px;height:34px;font-size:18px;line-height:1;cursor:pointer;color:#ae0a2b;padding:0}',
      '.scdc-nav[disabled]{opacity:.3;cursor:default}',
      '.scdc-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:3px}',
      '.scdc-dn{font-size:11px;color:#888;text-align:center;padding:4px 0;font-weight:600}',
      '.scdc-d{height:40px;border:0;border-radius:4px;background:#fff;font-family:inherit;font-size:14px;font-weight:600;color:#222;cursor:pointer;padding:0}',
      '.scdc-d:hover:not([disabled]){background:#f6e3e6}',
      '.scdc-d[disabled]{color:#c8c8c8;background:#f6f6f6;cursor:not-allowed;font-weight:400;text-decoration:line-through}',
      '.scdc-d.scdc-past[disabled]{text-decoration:none;background:transparent}',
      '.scdc-d.scdc-sel{background:#ae0a2b !important;color:#fff}',
      '.scdc-sel-txt{font-size:13.5px;margin-top:8px;color:#222}',
      '.scdc-time{width:100%;max-width:360px;height:44px;border:1px solid #ccc;border-radius:4px;padding:0 10px;font-family:inherit;font-size:15px;background:#fff}',
      '.scdc-msg{color:#ae0a2b;font-size:13px;font-weight:600;margin-top:8px;display:none}',
      '.scdc-err .scdc-msg{display:block}',
      '.scdc-line{border-top:1px solid #eee;padding:10px 0}',
      '.scdc-line:first-of-type{border-top:0}',
      '.scdc-ok{color:#1d7a3a;font-weight:600}',
      '.scdc-bad{color:#ae0a2b;font-weight:600}',
      '.scdc-btn{display:inline-block;background:#fff;border:1px solid #ae0a2b;color:#ae0a2b;border-radius:4px;padding:8px 14px;font-family:inherit;font-size:13px;cursor:pointer;margin-top:8px;letter-spacing:normal;text-transform:none;text-decoration:none}',
      '.scdc-lbl{letter-spacing:normal !important;text-transform:none !important;font-family:Jost,sans-serif !important}',
      '.scdc-legend{font-size:11.5px;color:#888;margin-top:6px}'
    ].join('');
    document.head.appendChild(s);
  }
  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'class') e.className = attrs[k]; else if (k === 'text') e.textContent = attrs[k]; else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), attrs[k]); else e.setAttribute(k, attrs[k]); }
    (kids || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }

  // Month calendar. opts: {group|groupKey, value, extraMin, onSelect(ymd)}
  function calendar(opts) {
    css();
    var g = opts.group || group(opts.groupKey) || builderGroup();
    var r = rules(g, opts.extraMin);
    var value = opts.value && r.status(opts.value) === 'ok' ? opts.value : (opts.value || '');
    var start = value && r.status(value) === 'ok' ? value : (r.first || r.min);
    var view = { y: +start.slice(0, 4), m: +start.slice(5, 7) - 1 };
    var root = h('div', { class: 'scdc-cal', role: 'group', 'aria-label': 'Delivery date' });
    function monthKey(y, m) { return y * 12 + m; }
    function draw() {
      root.innerHTML = '';
      var minK = monthKey(+r.today.slice(0, 4), +r.today.slice(5, 7) - 1);
      var maxK = monthKey(+r.max.slice(0, 4), +r.max.slice(5, 7) - 1);
      var curK = monthKey(view.y, view.m);
      var prev = h('button', { type: 'button', class: 'scdc-nav', 'aria-label': 'Previous month', onclick: function () { if (curK > minK) { view.m--; if (view.m < 0) { view.m = 11; view.y--; } draw(); } } }, ['\u2039']);
      var next = h('button', { type: 'button', class: 'scdc-nav', 'aria-label': 'Next month', onclick: function () { if (curK < maxK) { view.m++; if (view.m > 11) { view.m = 0; view.y++; } draw(); } } }, ['\u203A']);
      if (curK <= minK) prev.disabled = true;
      if (curK >= maxK) next.disabled = true;
      root.appendChild(h('div', { class: 'scdc-head' }, [prev, h('span', { text: MONTH_LONG[view.m] + ' ' + view.y }), next]));
      var grid = h('div', { class: 'scdc-grid' });
      ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].forEach(function (d) { grid.appendChild(h('div', { class: 'scdc-dn', text: d })); });
      var first = view.y + '-' + ('0' + (view.m + 1)).slice(-2) + '-01';
      var lead = (dow(first) + 6) % 7;
      for (var i = 0; i < lead; i++) grid.appendChild(h('div'));
      for (var d = first; +d.slice(5, 7) - 1 === view.m; d = addDays(d, 1)) {
        var st = r.status(d);
        var b = h('button', { type: 'button', class: 'scdc-d' + (d === value ? ' scdc-sel' : '') + (d < r.today || d < r.min ? ' scdc-past' : ''), 'data-date': d, 'aria-label': pretty(d) + (st === 'ok' ? '' : ' unavailable'), text: String(+d.slice(8)) });
        if (st !== 'ok') b.disabled = true;
        else b.addEventListener('click', (function (dd) { return function () { value = dd; draw(); if (opts.onSelect) opts.onSelect(dd); }; })(d));
        grid.appendChild(b);
      }
      root.appendChild(grid);
      root.appendChild(h('div', { class: 'scdc-legend', text: 'Greyed-out dates are unavailable.' }));
    }
    draw();
    root.__set = function (v) { value = v; if (v) { view = { y: +v.slice(0, 4), m: +v.slice(5, 7) - 1 }; } draw(); };
    root.__rules = r;
    return root;
  }

  function timeSelect(slots, value, onChange) {
    var s = h('select', { class: 'scdc-time', 'aria-label': 'Delivery time' });
    s.appendChild(h('option', { value: '', text: 'Choose your delivery time' }));
    slots.forEach(function (t) { var o = h('option', { value: t, text: t12short(t) }); if (t === value) o.selected = true; s.appendChild(o); });
    s.addEventListener('change', function () { onChange(s.value); });
    return s;
  }

  function attrValue(title, ymd, time) { return title + ' |&| ' + ymdToDmy(ymd) + ' |&| ' + DOW[dow(ymd)] + ' |&| ' + t12(time); }
  function parseAttr(v) {
    if (!v || v.indexOf('|&|') < 0) return null;
    var p = v.split('|&|').map(function (x) { return x.trim(); });
    return { title: p[0], date: dmyToYmd(p[1] || ''), time: from12(p[3] || '') };
  }

  var saving = null;
  function saveAttrs(attrs) {
    var p = realFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .catch(function (e) { try { console.warn('[scdc] save failed', e); } catch (_) {} })
      .finally(function () { if (saving === p) saving = null; });
    saving = p; return p;
  }
  function baseAttrs() { return { calendar_type: 'product', 'Date Format': 'dd/mm/yy', _sc_dc: 'v1' }; }

  window.SCDC = {
    version: 1, active: ACTIVE, groups: GROUPS, group: group, builderGroup: builderGroup, groupForProduct: groupForProduct,
    rules: rules, calendar: calendar, timeSelect: timeSelect, pretty: pretty, t12: t12, t12short: t12short,
    check: function (groupKey, ymd, time, extraMin) { var g = (typeof groupKey === 'string' ? group(groupKey) : groupKey) || builderGroup(); return g ? rules(g, extraMin).check(ymd, time) : ''; },
    attrValue: attrValue, parseAttr: parseAttr
  };
  try { window.dispatchEvent(new Event('scdc:ready')); } catch (e) {}

  if (!ACTIVE) return;

  // Hide the old app's widgets wherever ours is in charge.
  function hideOdd(offscreen) {
    if (document.getElementById('scdc-hide-odd')) return;
    var s = document.createElement('style'); s.id = 'scdc-hide-odd';
    s.textContent = offscreen
      ? '.identixweb-product-order-delivery{position:absolute !important;left:-10000px !important;top:0 !important;width:400px !important;opacity:0 !important;pointer-events:none !important}'
      : '.identixweb-product-order-delivery,.pc-identixweb-order-delivery,[class*="identixweb-order-delivery"]{display:none !important}';
    document.head.appendChild(s);
  }

  // TEST PHASE ONLY: while the old app still guards Add to Cart on these products, copy our
  // choice into its hidden widget so its check passes. Removed once the app is switched off.
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function oddWidget() { return document.querySelector('.identixweb-product-order-delivery'); }
  function oddMatches(date, time) {
    var d = document.getElementsByClassName('deliveryDateValue')[0], t = document.getElementsByClassName('deliverytimeValue')[0];
    return !!(d && t && d.value === ymdToDmy(date) && t.value === t12(time));
  }
  function oddBridge(date, time) {
    var w = oddWidget(); if (!w || !date || !time || oddMatches(date, time)) return Promise.resolve(true);
    var steps = 0;
    function findDay() { return w.querySelector('[aria-label="' + date + '"]'); }
    function nav() {
      var d = findDay(); if (d || steps > 8) return Promise.resolve(d);
      var right = w.querySelector('.rmdp-arrow-container.rmdp-right, .rmdp-right'); if (!right) return Promise.resolve(null);
      right.click(); steps++; return wait(250).then(nav);
    }
    return nav().then(function (d) {
      if (!d) return false;
      d.click();
      return wait(600).then(function () {
        var sel = w.querySelector('.identixweb-order-delivery-deliveryTime .ant-select-selector') || w.querySelector('.ant-select-selector');
        if (!sel) return false;
        sel.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        return wait(600).then(function () {
          var o = Array.prototype.slice.call(document.querySelectorAll('.ant-select-item-option')).filter(function (x) { return x.textContent.trim() === t12(time); })[0];
          if (o) o.click();
          return wait(400).then(function () { return oddMatches(date, time); });
        });
      });
    }).catch(function () { return false; });
  }

  var ADD_SEL = '.avis-new-addcart-button, form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] input[name="add"], form[action*="/cart/add"] button[type="submit"]';
  function isAddUrl(u) { return /\/cart\/add(\.js)?(\?|$)/i.test(u || ''); }

  // ---------- product pages ----------
  function productPage() {
    var P = CFG.product; if (!P) return;
    var g = groupForProduct(P.id); if (!g) return;
    var BRIDGE = CFG.mode === 'test';
    hideOdd(BRIDGE); css();
    var key = 'product_' + P.variant;
    var state = { date: '', time: '' };
    var box = null, cal = null, msgEl = null, selTxt = null, timeEl = null;

    function currentVariant() {
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return f && f.value ? f.value : P.variant;
    }
    function valid() { return !rules(g).check(state.date, state.time); }
    function persist() {
      if (!state.date || !state.time) return Promise.resolve();
      var a = baseAttrs(); key = 'product_' + currentVariant(); a[key] = attrValue(P.title, state.date, state.time);
      if (BRIDGE) oddBridge(state.date, state.time);
      return saveAttrs(a);
    }
    function refreshText() {
      if (!selTxt) return;
      selTxt.textContent = state.date ? 'Delivery: ' + pretty(state.date) + (state.time ? ', ' + t12short(state.time) : ' \u2014 now choose a time') : '';
    }
    function showError() {
      if (!box) return;
      var err = rules(g).check(state.date, state.time);
      msgEl.textContent = err || '';
      box.classList.toggle('scdc-err', !!err);
      if (err) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function build() {
      var r = rules(g);
      box = h('div', { id: 'sc-dc', class: 'scdc-box' });
      box.appendChild(h('p', { class: 'scdc-title', text: 'Delivery date & time' }));
      box.appendChild(h('p', { class: 'scdc-sub', text: 'Required before adding to cart. ' + r.noticeText() }));
      box.appendChild(h('label', { class: 'scdc-lbl' }, ['Delivery date ', h('b', { text: '*' })]));
      cal = calendar({ group: g, value: state.date, onSelect: function (d) { state.date = d; refreshText(); box.classList.remove('scdc-err'); persist(); } });
      box.appendChild(cal);
      box.appendChild(h('label', { class: 'scdc-lbl' }, ['Delivery time ', h('b', { text: '*' })]));
      timeEl = timeSelect(g.slots, state.time, function (t) { state.time = t; refreshText(); box.classList.remove('scdc-err'); persist(); });
      box.appendChild(timeEl);
      selTxt = h('div', { class: 'scdc-sel-txt' }); box.appendChild(selTxt); refreshText();
      msgEl = h('div', { class: 'scdc-msg', role: 'alert' }); box.appendChild(msgEl);
      return box;
    }
    function mount() {
      if (box && document.body.contains(box)) return;
      var anchor = document.querySelector('.identixweb-product-order-delivery') || document.querySelector('.product__quantity');
      var ev = document.getElementById('sc-event-info');
      var el = box || build();
      if (ev && ev.parentNode) ev.parentNode.insertBefore(el, ev);
      else if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(el, anchor.nextSibling);
      else { var btn = document.querySelector(ADD_SEL); if (btn && btn.parentNode) btn.parentNode.insertBefore(el, btn); }
    }
    // Prefill from the cart if this product already has a date saved.
    realFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      var a = parseAttr((c.attributes || {})[key]);
      if (a && a.date && !state.date) { state.date = a.date; state.time = a.time; if (cal) cal.__set(a.date); if (timeEl) timeEl.value = a.time; refreshText(); }
    }).catch(function () {});

    var bridging = false;
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest(ADD_SEL) : null;
      if (!t) return;
      if (!valid()) { e.preventDefault(); e.stopImmediatePropagation(); showError(); return; }
      if (BRIDGE && oddWidget() && !oddMatches(state.date, state.time)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (bridging) return; bridging = true;
        oddBridge(state.date, state.time).then(function (ok) { bridging = false; if (ok) t.click(); else showError(); });
      }
    }, true);
    window.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '') || valid()) return;
      e.preventDefault(); e.stopImmediatePropagation(); showError();
    }, true);
    var wrappedFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isAddUrl(url)) return wrappedFetch.apply(this, arguments);
      var self = this, args = arguments;
      if (!valid()) { showError(); return Promise.resolve(new Response(JSON.stringify({ status: 422, message: 'Please choose a delivery date and time', description: 'Please choose a delivery date and time' }), { status: 422, headers: { 'Content-Type': 'application/json' } })); }
      return persist().then(function () { return saving || null; }).then(function () { return wrappedFetch.apply(self, args); });
    };
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__scdcUrl = u; return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (!isAddUrl(this.__scdcUrl)) return xSend.apply(this, arguments);
      var xhr = this, args = arguments;
      if (!valid()) { showError(); try { xhr.abort(); } catch (e) {} return; }
      persist().then(function () { xSend.apply(xhr, args); });
    };
    var tries = 0;
    (function poll() { mount(); if (++tries < 40) setTimeout(poll, 400); })();
    new MutationObserver(function () { if (box && !document.body.contains(box)) mount(); }).observe(document.body, { childList: true, subtree: true });
  }

  // ---------- cart (page + drawer guard) ----------
  var cartState = { ready: false, problems: [], lines: [] };
  function evaluateCart(c) {
    var attrs = c.attributes || {}, lines = [], problems = [], seen = {}, prune = {};
    (c.items || []).forEach(function (it) {
      var g = groupForProduct(it.product_id); if (!g) return;
      var k = 'product_' + it.variant_id; if (seen[k]) return; seen[k] = 1;
      var a = parseAttr(attrs[k]) || { date: '', time: '' };
      var r = rules(g); var err = r.check(a.date, a.time);
      var line = { key: k, title: it.product_title, group: g, date: a.date, time: a.time, err: err };
      lines.push(line); if (err) problems.push(line);
    });
    // Order-builder orders: check the event date against the shared calendar too.
    var hasBuilder = (c.items || []).some(function (it) { return it.vendor === 'Swee Choon Catering v2' || (it.sku && it.sku.indexOf('CAT-') === 0); });
    if (hasBuilder && attrs['Event date']) {
      var bg = builderGroup(); var err2 = bg ? rules(bg).check(attrs['Event date']) : '';
      var bl = { key: 'Event date', title: 'Your catering order', group: bg, date: attrs['Event date'], time: '', err: err2, builder: true };
      lines.push(bl); if (err2) problems.push(bl);
    }
    Object.keys(attrs).forEach(function (k) { if (/^product_\d+$/.test(k) && !seen[k] && attrs[k]) prune[k] = ''; });
    cartState = { ready: true, problems: problems, lines: lines, prune: prune };
    return cartState;
  }
  function refreshCart() {
    return realFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(evaluateCart).catch(function () { return cartState; });
  }

  var cartPanel = null;
  function renderCartPanel() {
    var wrap = document.querySelector('.cart__checkout-wrapper');
    if (!wrap) return;
    if (cartPanel && cartPanel.parentNode) cartPanel.parentNode.removeChild(cartPanel);
    cartPanel = null;
    var direct = cartState.lines.filter(function (l) { return !l.builder || l.err; });
    if (!direct.length) return;
    css();
    cartPanel = h('div', { id: 'sc-dc', class: 'scdc-box' + (cartState.problems.length && /sc-dc/.test(location.hash) ? ' scdc-err' : '') });
    cartPanel.appendChild(h('p', { class: 'scdc-title', text: 'Delivery date & time' }));
    direct.forEach(function (l) {
      var row = h('div', { class: 'scdc-line' });
      row.appendChild(h('div', { text: l.title, style: 'font-weight:600' }));
      if (!l.err) {
        row.appendChild(h('div', { class: 'scdc-ok', text: '\u2713 ' + pretty(l.date) + (l.time ? ', ' + t12short(l.time) : '') }));
        var chg = h('button', { type: 'button', class: 'scdc-btn', text: 'Change date or time' });
        row.appendChild(chg);
        chg.addEventListener('click', function () { chg.style.display = 'none'; row.appendChild(editor(l)); });
      } else {
        row.appendChild(h('div', { class: 'scdc-bad', text: l.date ? l.err : 'Please choose a delivery date and time.' }));
        if (l.builder) row.appendChild(h('a', { href: '/pages/build-your-own-dim-sum-catering', class: 'scdc-btn', text: 'Choose a new date in the order builder' }));
        else row.appendChild(editor(l));
      }
      cartPanel.appendChild(row);
    });
    cartPanel.appendChild(h('div', { class: 'scdc-msg', role: 'alert', text: 'Please fix the delivery date above before checking out.' }));
    wrap.parentNode.insertBefore(cartPanel, wrap);
  }
  function editor(l) {
    var st = { date: l.err ? '' : l.date, time: l.time };
    var box = h('div', { style: 'margin-top:8px' });
    var save = h('button', { type: 'button', class: 'scdc-btn', text: 'Save delivery date', style: 'background:#ae0a2b;color:#fff' });
    var note = h('div', { class: 'scdc-bad', style: 'margin-top:6px' });
    box.appendChild(calendar({ group: l.group, value: st.date, onSelect: function (d) { st.date = d; } }));
    box.appendChild(h('div', { style: 'height:8px' }));
    box.appendChild(timeSelect(l.group.slots, st.time, function (t) { st.time = t; }));
    box.appendChild(h('div', {}, [save])); box.appendChild(note);
    save.addEventListener('click', function () {
      var err = rules(l.group).check(st.date, st.time);
      if (err) { note.textContent = err; return; }
      var a = baseAttrs(); a[l.key] = attrValue(l.title, st.date, st.time);
      save.disabled = true; save.textContent = 'Saving\u2026';
      saveAttrs(a).then(refreshCart).then(renderCartPanel);
    });
    return box;
  }
  function blocksCheckout() { return cartState.ready && cartState.problems.length > 0; }

  function cartGuard() {
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[name="checkout"], .cart__checkout, a[href$="/checkout"], a[href*="/checkout?"], .additional-checkout-button, .shopify-payment-button__button') : null;
      if (!t || t.closest('form[action*="/cart/add"]')) return;
      if (!blocksCheckout()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (/^\/cart\/?$/.test(location.pathname)) { renderCartPanel(); if (cartPanel) { cartPanel.classList.add('scdc-err'); cartPanel.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
      else location.href = '/cart#sc-dc';
    }, true);
    var wf = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = wf.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/i.test(url)) res.then(function () { setTimeout(function () { refreshCart().then(function () { if (/^\/cart\/?$/.test(location.pathname)) renderCartPanel(); }); }, 200); }, function () {});
      return res;
    };
  }

  function start() {
    productPage();
    cartGuard();
    refreshCart().then(function (s) {
      if (s.prune && Object.keys(s.prune).length) saveAttrs(s.prune);
      if (/^\/cart\/?$/.test(location.pathname)) {
        if (s.lines.some(function (l) { return !l.builder; })) hideOdd();
        renderCartPanel();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
